/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { Context } from '~context/TranslationsProvider';

import styles from './not-found.module.scss';

const PageNotFound = ({ upcomingMatchesLink = '/fodbold/live-stream-udbyder' }) => {
  const { translations } = useContext(Context) || {};

  return (
    <div className={styles.errorPage}>
      <LazyImage src="../../../../../../images/error-tv.png" alt="404" width={259} height={308} />
      <h2>{translate(translations, 'page_does_not_exist', 'Oops - page does not exist')}</h2>
      <h3>
        {translate(
          translations,
          'looking_for_league_team_match',
          'Are you looking for a league, a team or a specific match?'
        )}
      </h3>
      <Button
        to="/"
        className="soccer"
        btnText={
          <>
            <FaChevronCircleRight />
            {translate(translations, 'go_to_home_page', 'Go to home page')}
          </>
        }
        gtmClass="404-gtm"
      />
      <Button
        to={upcomingMatchesLink}
        className="soccer"
        btnText={
          <>
            <FaChevronCircleRight />
            {translate(translations, 'upcoming_matches', 'Upcoming matches')}
          </>
        }
        gtmClass="404-gtm"
      />
    </div>
  );
};

PageNotFound.propTypes = {
  upcomingMatchesLink: PropTypes.string,
};

export default PageNotFound;
